import { Col, Container, Row } from 'react-bootstrap';
import { useState, useEffect, useRef } from "react";
import { PieChart } from "recharts";
import CollegeWiseRusaReport from './assets/ApRusa/CollegeWiseRusaReport';
import { config } from './CommonUtils/CommonURLS';
import axios from 'axios';
import ParliamentwiseSchemeDetails from './assets/ApRusa/ParliamentwiseSchemeDetails';
import DistiwiseDataRepresentation from './assets/ApRusa/DistiwiseDataRepresentation';
import { Form, FormikProvider, useFormik } from 'formik';
import { Modal, } from "react-bootstrap";
import { Box, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';;
import CollegeFinancialContent from './CollegeFinancialContent';
import OveralolProjects from './OveralolProjects';
import { CommonAxiosGet } from './CommonUtils/CommonAxios';

// ================= TAB DATA =================
import step1 from "../public/images/stepper-img1.svg";
import step2 from "../public/images/stepper-img2.svg";
import step3 from "../public/images/stepper-img3.svg";
import step4 from "../public/images/stepper-img4.svg";
import step5 from "../public/images/stepper-img5.svg";
import step6 from "../public/images/stepper-img4.svg";

const tabs = [
    { key: "home", label: "Overall Project Status", icon: step1 },
    { key: "option2", label: " Assembly/Parliament Wise Institution Details ", icon: step2 },
    { key: "option3", label: "District Wise Project Status ", icon: step3 },
    { key: "option4", label: "Institution Wise Financial Report", icon: step4 },
    { key: "option5", label: "Institution Wise Status (Completed /Ongoing)", icon: step5 },
    { key: "option6", label: "Institution / University Outcome (Completed /Ongoing)", icon: step6 },
];
function AffiTabs() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visibleCount, setVisibleCount] = useState(5);
    // ================= VISIBLE TABS WINDOW =================
    const startIndexnew = Math.min(
        Math.max(activeIndex - Math.floor(visibleCount / 2), 0),
        Math.max(tabs.length - visibleCount, 0)
    );

    const visibleTabs = tabs.slice(startIndexnew, startIndexnew + visibleCount);

    // ================= ARROW ACTIONS =================
    const nextTab = () => {
        if (activeIndex < tabs.length - 1) {
            setActiveIndex(prev => prev + 1);
        }
    };

    const prevTab = () => {
        if (activeIndex > 0) {
            setActiveIndex(prev => prev - 1);
        }
    };



    //---------------------Tabs-----------------------
    const navRef = useRef(null);
    const sliderRef = useRef(null);
    const [activeTab, setActiveTab] = useState("home");
    const [phaseName, setPhaseName] = useState("RUSA 1");

    useEffect(() => {
        const nav = navRef.current;
        const slider = sliderRef.current;
        if (!nav || !slider) return;

        const activeLink = nav.querySelector(".nav-link.active");
        if (!activeLink) return;

        const li = activeLink.parentElement;
        const isMobile = window.innerWidth < 576;

        slider.style.opacity = "1";

        if (isMobile) {
            slider.style.transform = `translateY(${li.offsetTop}px)`;
            slider.style.height = `${li.offsetHeight}px`;
            slider.style.width = "100%";
        } else {
            slider.style.transform = `translateX(${li.offsetLeft}px)`;
            slider.style.width = `${li.offsetWidth}px`;
            slider.style.height = "100%";
        }
    }, [activeTab]);

    const COLORS = ["#c96a11", "#0b5d2a", "#b89a8bff"];


    // ============wave chart==================
    const [ClgList, setclgList] = useState([]);
    function GetclgList() {
        let url = `${config.url.API_URL}getRusaUpdationCollUnvdata`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setclgList(res?.data?.data)

            }
            else {
                setclgList([]);

            }
        });
    }

    const [overallPieStatus, setOverallPieStatus] = useState([]);
    function OverAllPieData(phasename) {
        let url = `${config.url.API_URL}getOverallProjectStatus?rusa_phase=${phasename}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {

                setOverallPieStatus(res?.data?.ProjectStatus)

            }
            else {
                setOverallPieStatus([]);

            }
        });
    }


    const toCr = (value) => +(value / 10000000).toFixed(2);

    const [overallfinanceCount, setOverallfinanceCount] = useState([]);

    function OverAllFinanceCount(phasename) {
        if (!phasename || phasename.trim() === "") {
            console.log("Skipping API call — invalid phasename:", phasename);
            return;
        }
        let url = `${config.url.API_URL}getOverallFinancialStatus?rusa_phase=${phasename}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setOverallfinanceCount(res?.data?.FinancialStatus);
            } else {
                setOverallfinanceCount([]);
            }
        });
    }



    useEffect(() => {
        GetclgList();
        OverAllPieData(phaseName);
        OverAllFinanceCount(phaseName);
        ShowComponent(phaseName);

    }, [activeTab]);
    const ongoing = overallPieStatus?.[0]?.ongoing || 0;
    const completed = overallPieStatus?.[0]?.completed || 0;
    const billsPending = overallPieStatus?.[0]?.bills_pending || 0;

    const total = ongoing + completed + billsPending;

    // __________________Clg wise bar graph_________________________

    // component wise line graph logic-----------------
    const [componentdata, setComponentdata] = useState([]);
    function ShowComponent(phasename) {
        if (!phasename || phasename.trim() === "") {
            console.log("Skipping API call — invalid phasename:", phasename);
            return;
        }
        let url = `${config.url.API_URL}getCmpwiseClgData?rusa_phase=${phasename}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setComponentdata(res?.data?.CmpwiseClgData);

            }
            else {
                setComponentdata([]);

            }
        });
    }

    const pieDataprojectstatus = overallPieStatus?.length
        ? [
            { name: "Ongoing", value: overallPieStatus[0]?.ongoing || 0 },
            { name: "Completed", value: overallPieStatus[0]?.completed || 0 },
            { name: "Bills Pending", value: overallPieStatus[0]?.bills_pending || 0 }
        ]
        : [];
    const apiData = overallfinanceCount[0]; // your API response object

    const totalApproved = toCr(apiData?.tot_approve || 0);
    const totalUtilised = toCr(apiData?.tot_utilised || 0);
    const balance = +(totalApproved - totalUtilised).toFixed(2);




    const RusaIFormik = useFormik({
        initialValues: {
            phasestatus: "",
            univcoll: "",
            clgname: "",

        },
        // validationSchema: validationSchema,
        onSubmit: (values) => {
            GetRusaIDetails(values);


        },
    });
    const [errormsg, setErrormsg] = useState('')

    const [rusaData, setRusaData] = useState([]);
    function GetRusaIDetails(values) {
        let url = `${config.url.API_URL}getRUSA1and2data?CollUnv=${values?.univcoll}&project_status=${values?.phasestatus}&rusa_phase=${phaseName}`;


        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {

                setRusaData(res.data?.data);
                setErrormsg(true)

            }
            else {
                setRusaData([]);
                setErrormsg(false);

            }
        });
    }
    const [modal, setModal] = useState(false)
    const [Clgname, setClgname] = useState('');

    const [clgdata, setClgdata] = useState([]);
    function GetCollegeData(phase, clgcode) {

        // if (!clgcode) {
        //     return
        // }
        const url = `${config.url.API_URL}getDetailsByInst?rusa_phase=${phase}&collcode=${clgcode}`;
        axios.get(url).then((res) => {
            if (res?.data?.scode === "01") {
                setClgdata(res.data.getDtls || []);
            } else {
                setClgdata([]);
            }
        });
    }



    const d = clgdata[0] || {};

    const isRusa = phaseName === "RUSA 1" || phaseName === "RUSA 2";
    const isPMUsha = phaseName === "PMUSHA";

    // handle API typo for central utilised
    const centralUtilised =
        d.central_share_utilised ??
        d.central_share_utilized ??
        0;

    // state utilised
    const stateUtilised = d.state_share_utilised ?? 0;

    // ----------------------------
    // ⭐ RUSA DATASET (3 bars)
    // ----------------------------
    const datasetRUSA = [
        {
            total: "Total Approved",
            State: (d.state_share_approved || 0) / 100000,
            Central: (d.central_share_approved || 0) / 100000,
        },

        {
            total: "Total Utilised",
            State: stateUtilised / 100000,
            Central: centralUtilised / 100000,
        },
    ];

    // ----------------------------
    // ⭐ PMUSHA DATASET (2 bars)
    // ----------------------------
    const datasetPMUSHA = [
        {
            total: "Total Approved",
            State: (d.state_share_approved || 0) / 100000,
            Central: (d.central_share_approved || 0) / 100000,
        },
        {
            total: "Total Utilised",
            State: stateUtilised / 100000,
            Central: centralUtilised / 100000,
        },
    ];

    // ----------------------------
    // ⭐ FINAL DATASET → USE THIS IN BARCHART
    // ----------------------------
    const datasetFinal = isPMUsha ? datasetPMUSHA : datasetRUSA;
    const stateApproved = d?.state_share_approved || 0;
    const centralApproved = d?.central_share_approved || 0;

    const StateUtilised = d?.state_share_utilised || 0;
    const CentralUtilised = d?.central_share_utilised || 0;

    const TotalApproved = stateApproved + centralApproved;
    const TotalUtilised = StateUtilised + CentralUtilised;

    const remainingBalance = TotalApproved - TotalUtilised;
    const sideDetails = [
        {
            label: "Total Approved",
            State: stateApproved,
            Central: centralApproved,
            Total: TotalApproved,
        },
        {
            label: "Total Utilised",
            State: StateUtilised,
            Central: CentralUtilised,
            Total: TotalUtilised,
        },
        {
            label: "Remaining Balance",
            State: stateApproved - StateUtilised,
            Central: centralApproved - CentralUtilised,
            Total: remainingBalance,
        },
    ];

    // -------------------------------------------------------------------------
    const steps = [
        {
            label: "Overall Project Status",
            component: <OveralolProjects key={phaseName} selectedtab={phaseName} />,
        },
        {
            label: "Assembly/Parliament Wise Institution Details ",
            component: <ParliamentwiseSchemeDetails key={phaseName} rusaPhase={phaseName} />,
        },
        {
            label: "District Wise Project Status",
            component: <DistiwiseDataRepresentation key={phaseName} rusaPhase={phaseName} />,
        },
        {
            label: "Institution Wise Financial Report",
            component: <CollegeFinancialContent key={phaseName} selectedtab={phaseName} />,
        },

        {
            label: "Institution  Outcome (Completed / Ongoing)",
            component: <CollegeWiseRusaReport ClgList={ClgList !== undefined ? ClgList : []} />
        },
    ];

    const [activeStep, setActiveStep] = useState(0);

    const nextStep = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep(prev => prev + 1);
        }
    };

    const prevStep = () => {
        if (activeStep > 0) {
            setActiveStep(prev => prev - 1);
        }
    };


    return (
        <>
            {/* <Header /> */}

            <FormikProvider value={RusaIFormik}>
                <Form onChange={RusaIFormik?.handleChange} onSubmit={RusaIFormik?.handleSubmit} className="affl-form" >
                    <Modal show={modal} onHide={() => setModal(false)} size="xl" centered backdrop="static" >
                        <Modal.Header style={{ backgroundColor: "#795A1D", }} closeButton></Modal.Header>
                        <Modal.Body>
                            <div className="graphical-bar-chart">
                                <div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        <h3
                                            style={{
                                                margin: 0,
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                color: "#4E1E03",
                                                letterSpacing: "0.5px",
                                            }}
                                        >
                                            {Clgname}  - Graphical Representation of Institution Wise Financial Details
                                        </h3>
                                    </div>
                                </div>


                                {clgdata?.length > 0 && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 6,
                                            mt: 4,
                                            alignItems: "flex-start",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {/* 📊 Bar Chart & Financial Details */}
                                        <Row sx={{ width: "100%" }}>
                                            <Col
                                                xs={12}
                                                sm={12}
                                                md={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 12}
                                                lg={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 12}
                                                xl={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 12}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: 4,
                                                        flex: 1,
                                                        minWidth: "600px",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "70%",
                                                            overflowX: "auto",
                                                            overflowY: "visible",
                                                            pl: 2,
                                                        }}
                                                    >
                                                        <BarChart
                                                            height={400}
                                                            width={600}
                                                            dataset={datasetFinal}


                                                            margin={{ top: 60, right: 40, bottom: 80, left: 80 }}
                                                            xAxis={[
                                                                {
                                                                    dataKey: "total",
                                                                    scaleType: "band",
                                                                    tickLabelProps: () => ({
                                                                        fill: "#000",
                                                                        fontSize: 14,
                                                                        fontWeight: 600,
                                                                        textAnchor: "end",
                                                                        transform: "rotate(-30)",
                                                                    }),
                                                                },
                                                            ]}
                                                            yAxis={[
                                                                {
                                                                    label: "Amount (in Lakhs)",
                                                                    labelStyle: { fontWeight: "bold" },
                                                                    tickLabelStyle: { fontSize: 12 },
                                                                },
                                                            ]}
                                                            series={[
                                                                {
                                                                    dataKey: "State",
                                                                    label: "State Share",
                                                                    stack: "combined",
                                                                    color: "#9cb984ff",
                                                                    valueFormatter: (v) => `${v?.toLocaleString("en-IN")} L`,

                                                                },
                                                                {
                                                                    dataKey: "Central",
                                                                    label: "Central Share",
                                                                    stack: "combined",
                                                                    color: "rgba(48, 160, 117, 0.47)",
                                                                    valueFormatter: (v) => `${v?.toLocaleString("en-IN")} L`,

                                                                },
                                                            ]}

                                                            legend={{
                                                                direction: "row",
                                                                position: { vertical: "top", horizontal: "center" },
                                                            }}


                                                        />

                                                        <b style={{ color: "brown" }}>
                                                            Remarks:{clgdata[0]?.remarks || "N/A"}

                                                        </b>
                                                    </Box>
                                                    <Box sx={{ width: "22%" }}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                mb: 2,
                                                                fontWeight: 600,
                                                                color: "#6e0d0d",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            College Financial Details
                                                        </Typography>

                                                        {sideDetails?.map(item => (
                                                            <Box
                                                                key={item.label}
                                                                sx={{
                                                                    mb: 2,
                                                                    p: 1.5,
                                                                    borderRadius: 2,
                                                                    backgroundColor: "#fafafa",
                                                                    boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                                                                }}
                                                            >
                                                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                                    {item.label} :{" "}
                                                                    <span
                                                                        style={{
                                                                            color:
                                                                                item.label === "Remaining Balance" && item.Total < 0
                                                                                    ? "red"
                                                                                    : "#0b5d1e",
                                                                        }}
                                                                    >
                                                                        {(item.Total / 100000).toFixed(2)} L
                                                                    </span>
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    State: <b>{(item.State / 100000).toFixed(2)} L</b>
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    Central: <b>{(item.Central / 100000).toFixed(2)} L</b>
                                                                </Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>



                                                </Box>
                                            </Col>

                                            {!!clgdata[0]?.no_of_faculties_benefitted &&
                                                !!clgdata[0]?.no_of_stud_benifitted && (

                                                    <Col
                                                        xs={12}
                                                        sm={12}
                                                        md={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 0}
                                                        lg={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 0}
                                                        xl={clgdata[0]?.no_of_faculties_benefitted || clgdata[0]?.no_of_stud_benifitted ? 6 : 0}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: 3,
                                                                mt: 3,
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="h6"
                                                                sx={{
                                                                    mb: 2,
                                                                    fontWeight: 500,
                                                                    color: "#6e0d0dff",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                Beneficiary Details
                                                            </Typography>

                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: 4,
                                                                    flexWrap: "wrap",
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                <Box sx={{ width: { xs: "100%", md: "35%" } }}>
                                                                    <Typography
                                                                        variant="h6"
                                                                        sx={{ mb: 2, color: "#0A2E4D" }}
                                                                    >
                                                                        {clgdata[0]?.inst_name}
                                                                    </Typography>

                                                                    {[
                                                                        {
                                                                            name: "Faculties Benefitted",
                                                                            value: clgdata[0]?.no_of_faculties_benefitted || 0,
                                                                            color: "#a1c8e7ff",
                                                                        },
                                                                        {
                                                                            name: "Students Benefitted",
                                                                            value: clgdata[0]?.no_of_stud_benifitted || 0,
                                                                            color: "#a1877fff",
                                                                        },
                                                                    ].map((item) => (
                                                                        <Box
                                                                            key={item?.name}
                                                                            sx={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                mb: 1.2,
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                sx={{
                                                                                    width: 18,
                                                                                    height: 18,
                                                                                    borderRadius: "50%",
                                                                                    backgroundColor: item.color,
                                                                                    mr: 1.5,
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="body1"
                                                                                sx={{ color: "#333", fontWeight: 500 }}
                                                                            >
                                                                                {item.name}: <b>{item.value}</b>
                                                                            </Typography>
                                                                        </Box>
                                                                    ))}

                                                                    <Box
                                                                        sx={{
                                                                            mt: 2,
                                                                            pt: 1,
                                                                            borderTop: "1px solid #ccc",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 1,
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            sx={{ fontWeight: 600, color: "#0A2E4D" }}
                                                                        >
                                                                            Total Beneficiaries:
                                                                        </Typography>
                                                                        <Typography
                                                                            sx={{ fontWeight: 700, color: "#2E7D32" }}
                                                                        >
                                                                            {(
                                                                                (clgdata[0]?.no_of_faculties_benefitted || 0) +
                                                                                (clgdata[0]?.no_of_stud_benifitted || 0)
                                                                            ).toLocaleString("en-IN")}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>

                                                                <Box sx={{ width: { xs: "100%", md: "60%" }, height: 350 }}>
                                                                    <PieChart
                                                                        width={400}
                                                                        height={320}
                                                                        series={[
                                                                            {
                                                                                data: [
                                                                                    {
                                                                                        id: 0,
                                                                                        label: "Faculties",
                                                                                        value: clgdata[0]?.no_of_faculties_benefitted || 0,
                                                                                        color: "#a1c8e7ff",
                                                                                    },
                                                                                    {
                                                                                        id: 1,
                                                                                        label: "Students",
                                                                                        value: clgdata[0]?.no_of_stud_benifitted || 0,
                                                                                        color: "#a1877fff",
                                                                                    },
                                                                                ],
                                                                                highlightScope: { faded: "global", highlighted: "item" },
                                                                                faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
                                                                                arcLabel: (item) => `${item.value}`,
                                                                                arcLabelMinAngle: 10,
                                                                                arcLabelRadius: "60%",
                                                                                arcLabelPlacement: "center",
                                                                            },
                                                                        ]}
                                                                        sx={{
                                                                            ".MuiChartsLegend-root": { display: "none" },
                                                                            ".MuiChartsArcLabel": {
                                                                                fontSize: 16,
                                                                                fontWeight: 700,
                                                                                fill: "#fff",
                                                                            },
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Box>
                                                        </Box>


                                                    </Col>
                                                )}
                                        </Row>
                                    </Box>
                                )}
                            </div>
                        </Modal.Body>
                    </Modal>
                    <div>

                        <Container fluid className='p-0'>
                            {/* <div className="text-center">
                                <button
                                    style={{
                                        background: "linear-gradient(135deg, #42c7d6, #1e90ff)",
                                        color: "#fff",
                                        border: "none",
                                        padding: "12px 36px",
                                        borderRadius: "30px",
                                        fontWeight: "600",
                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                                        cursor: "pointer"
                                    }}
                                >
                                    Total Scheme Overview
                                </button>
                            </div> */}

                            <div className='affl-wholediv'>
                                <div className="tile" id="tile-1">
                                    {/* ---------------- NAV ---------------- */}

                                    <div className="tab-nav-wrapper">
                                        <ul className="nav nav-tabs" ref={navRef}>
                                            <div className="slider" ref={sliderRef}></div>

                                            <li className="nav-item">
                                                <button
                                                    href="#"
                                                    role="button"
                                                    tabIndex={0}
                                                    className={`nav-link ${activeTab === "home" ? "active" : ""}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setActiveTab("home");
                                                        setActiveIndex(0);
                                                        OverAllPieData(phaseName);
                                                        OverAllFinanceCount(phaseName);
                                                        ShowComponent(phaseName);
                                                        setPhaseName("RUSA 1");
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === " ") {
                                                            e.preventDefault();
                                                            setActiveTab("home");
                                                            setActiveIndex(0);
                                                            OverAllPieData(phaseName);
                                                            OverAllFinanceCount(phaseName);
                                                            ShowComponent(phaseName);
                                                            setPhaseName("RUSA 1");

                                                        }
                                                    }}
                                                >
                                                    RUSA I
                                                </button>
                                            </li>

                                            {/* RUSA II */}
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
                                                    role="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setActiveTab("profile");
                                                        setActiveIndex(1);
                                                        OverAllPieData(phaseName);
                                                        OverAllFinanceCount(phaseName);
                                                        ShowComponent(phaseName);
                                                        setPhaseName("RUSA 2");


                                                    }}
                                                >
                                                    RUSA II
                                                </button>
                                            </li>

                                            {/* PM USHA */}
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === "contact" ? "active" : ""}`}
                                                    role="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setActiveTab("contact");
                                                        setActiveIndex(2);
                                                        OverAllPieData(phaseName);
                                                        OverAllFinanceCount("PMUSHA");
                                                        ShowComponent("PMUSHA");
                                                        setPhaseName("PMUSHA");


                                                    }}
                                                >
                                                    PM USHA
                                                </button>
                                            </li>

                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === "contact1" ? "active" : ""}`}
                                                    role="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setActiveTab("contact1");
                                                        setActiveIndex(2);
                                                        OverAllPieData(phaseName);
                                                        OverAllFinanceCount("total");
                                                        ShowComponent("total");
                                                        setPhaseName("total");
                                                    }}
                                                >
                                                    Total Scheme Overview
                                                </button>
                                            </li>

                                        </ul>
                                    </div>

                                    {/* ---------------- TAB CONTENT (EXACT STRUCTURE) ---------------- */}
                                    <div className="tab-content mt-4">
                                        {(activeTab === "home" || activeTab === "profile" || activeTab === "contact" || activeTab === "contact1") && (
                                            <div className="tab-pane fade show active">
                                                <div className='project-statdiv'>
                                                    <Row className="p-0 m-0">
                                                        <Col xs={6} sm={6} md={6} lg={3} className='mb-3'>
                                                            <div className='affl-totcard affl-totcard1'>
                                                                <div className='aff-cardhead'>
                                                                    <div className='affi-card-content'>
                                                                        <div className='total-num total-imgdiv'>
                                                                            <img src='../images/total.svg' alt='' className='img-fluid' />
                                                                        </div>
                                                                        <h5 className='mb-0'>Total</h5>
                                                                    </div>
                                                                    <div className='total-div'>
                                                                        <p className='mb-0'>{total}</p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} sm={6} md={6} lg={3} className='mb-3'>
                                                            <div className='affl-comcard affl-totcard affl-totcard3'>
                                                                <div className='aff-cardhead'>
                                                                    <div className='affi-card-content'>
                                                                        <div className='total-num total-imgdiv'>
                                                                            <img src='../images/complete.svg' alt='' className='img-fluid' />
                                                                        </div>
                                                                        <h5 className='mb-0'>Completed</h5>
                                                                    </div>
                                                                    <div className='total-div '>
                                                                        <p className='mb-0'>{completed}</p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} sm={6} md={6} lg={3} className='mb-3'>
                                                            <div className='affl-ongcard affl-totcard affl-totcard2'>
                                                                <div className='aff-cardhead'>
                                                                    <div className='affi-card-content'>
                                                                        <div className='total-num total-imgdiv'>
                                                                            <img src='../images/ongoing.svg' alt='' className='img-fluid' />
                                                                        </div>
                                                                        <h5 className='mb-0'>Ongoing</h5>
                                                                    </div>
                                                                    <div className='total-div '>
                                                                        <p className='mb-0'>{ongoing}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} sm={6} md={6} lg={3} className='mb-3'>
                                                            <div className='affl-pencard affl-totcard affl-totcard4'>
                                                                <div className='aff-cardhead'>
                                                                    <div className='affi-card-content'>
                                                                        <div className='total-num total-imgdiv'>
                                                                            <img src='../images/pending.svg' alt='' className='img-fluid' />
                                                                        </div>
                                                                        <h5 className='mb-0'>Works Completed <br />– Bills Pending </h5>
                                                                    </div>
                                                                    <div className='total-div '>
                                                                        <p className='mb-0'>{billsPending}</p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>

                            </div>

                        </Container>

                        {/* ================= STEPPER ================= */}
                        <div className="stepper-wrapper">
                            <div className="stepper">
                                {visibleTabs?.map((step, index) => {
                                    const actualIndex = startIndexnew + index;
                                    const isActive = actualIndex === activeStep;

                                    return (
                                        <div className="step-item" key={step.key}>
                                            <button type='button'
                                                className={`step-circle ${isActive ? "active" : ""}`}
                                                onClick={() => setActiveStep(actualIndex)}   // ✅ FIX
                                            >
                                                <img
                                                    src={step.icon}
                                                    alt={step.label}
                                                    className="step-icon"
                                                />
                                            </button>

                                            <div className={`step-label ${isActive ? "active-label" : ""}`}>
                                                {step.label}
                                            </div>

                                            {index !== visibleTabs.length - 1 && (
                                                <div className="step-line" />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>


                        {/* ================= STEP CONTENT ================= */}
                        <div className="step-content">
                            {steps[activeStep].component}
                        </div>
                    </div>

                </Form>
            </FormikProvider>

        </>
    );
}

export default AffiTabs;